module.exports = __webpack_public_path__ + "static/media/merch_logo.11dcf768.svg";